import React, { Component } from "react";
import { compose } from "redux";

import Link from "admin/shared/ui/Link.Component";
import PropTypes from "prop-types";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

// icons
import RefreshIcon from "@material-ui/icons/Cached";
import RegisterIcon from "@material-ui/icons/BorderColor";
import MatchIcon from "@material-ui/icons/PlaylistAddCheck";

// custom markup
import RetractableSidebar, {
  activeStyle,
} from "../../home/components/Retractable.Sidebar";

import { transactionTypesKeysSorted } from "admin/shared/dictionary/enums";

import { dateTypes } from "../Statistics.Helper";

import { statisticsConnector } from "../../../services/statistics/connector";

import moment from "moment";

class StatisticsComponent extends Component {
  timer = false;

  constructor(props) {
    super(props);

    this.state = {
      timerCount: 0,
      timerMax: 15, // data
      selectedRangeType: dateTypes.day,
      openDialog: false,
      stateChanged: false,
      from: new Date(this.getLastWeek(new Date())),
      to: new Date(this.getToday(new Date())),
      actionTypesToDisplay: {
        Deposit: true,
        Investment: true,
        Interest: true,
      },
    };
  }

  calculateNewConfig = () => {
    this.props.fetchStatistics(
      this.state.from,
      this.state.to,
      this.state.selectedRangeType,
      this.state.actionTypesToDisplay,
    );

    this.setState({ stateChanged: false });
  };

  getLastWeek(date) {
    return moment(new Date(date)).subtract(7, "days").hour(0).minute(0);
  }

  getToday(date) {
    return moment(new Date(date)).hour(23).minute(59);
  }

  handleOpen = () => {
    this.setState({ openDialog: true });
  };

  handleClose = () => {
    this.setState({ openDialog: false });
  };

  setFromDate = (val) => {
    this.setState({
      stateChanged: true,
      from: new Date(moment(val).hour(0).minute(0)),
    });
  };

  setToDate = (val) => {
    this.setState({
      stateChanged: true,
      to: new Date(moment(val).hour(23).minute(59)),
    });
  };

  changeCheckBox = (key) => {
    this.setState({
      stateChanged: true,
      actionTypesToDisplay: Object.assign({}, this.state.actionTypesToDisplay, {
        [key]: !this.state.actionTypesToDisplay[key],
      }),
    });
  };

  componentWillUnmount = () => {
    this.clearIntervals();
  };

  componentDidMount = () => {
    if (!this.props.statistics.calculated) {
      this.props.fetchStatistics(
        this.state.from,
        this.state.to,
        this.state.selectedRangeType,
        this.state.actionTypesToDisplay,
      );
    }
  };

  attachIntervals = (count = 5) => {
    this.setState({ timerCount: count, timerMax: count });

    setTimeout(() => {
      this.setState({ ...this.state, timerCount: 0 });
    }, count * 1000);
    this.timer = setInterval(() => {
      var timerCount =
        this.state.timerCount != 0
          ? this.state.timerCount - 1
          : clearInterval(this.timer) | 0;
      this.setState({ ...this.state, timerCount });
    }, 1000);
  };

  clearIntervals = () => {
    clearInterval(this.timer);
    this.timer = false;
  };

  resetIntervals = (count = 15) => {
    this.clearIntervals();
    this.attachIntervals(count);
  };

  handleRangeTypeChange = (event) => {
    this.setState({
      selectedRangeType: event.target.value,
      stateChanged: true,
    });
  };

  getMatchedData = () => {};

  render() {
    let wrapperStyle = {
      display: "flex",
      minHeight: "100%",
    };

    return (
      <div style={wrapperStyle}>
        <RetractableSidebar storageKey="accounting">
          <List>
            <ListItem disabled={true}>
              <ListItemIcon>
                <div />
              </ListItemIcon>
              <ListItemText primary="Statistics:" />
            </ListItem>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"statisticsTransactions"}
            >
              <ListItem button>
                <ListItemIcon>
                  <RegisterIcon />
                </ListItemIcon>
                <ListItemText primary="Transactions" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"statisticsCurrent"}
            >
              <ListItem button>
                <ListItemIcon>
                  <MatchIcon />
                </ListItemIcon>
                <ListItemText primary="State of System" />
              </ListItem>
            </Link>
          </List>
        </RetractableSidebar>
        <div
          style={{
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          <div style={{ width: "100%", padding: "8px 16px" }}>
            <Card>
              <CardContent>
                <div>Selecte date range to load transactions</div>
                <div style={{ display: "flex" }}>
                  <div>
                    From:{" "}
                    <DatePicker
                      inputVariant="outlined"
                      className="small-datepicker"
                      helperText="From"
                      value={this.state.from}
                      onChange={this.setFromDate}
                    />
                  </div>
                  <div>
                    To:{" "}
                    <DatePicker
                      inputVariant="outlined"
                      className="small-datepicker"
                      helperText="To"
                      value={this.state.to}
                      onChange={this.setToDate}
                    />
                  </div>
                  <div>
                    Dispay Range
                    <div>
                      <TextField
                        size="small"
                        variant="outlined"
                        select
                        value={this.state.selectedRangeType}
                        onChange={this.handleRangeTypeChange}
                      >
                        <MenuItem value={dateTypes.day}>Days</MenuItem>
                        <MenuItem value={dateTypes.week}>Weeks</MenuItem>
                        <MenuItem value={dateTypes.month}>Months</MenuItem>
                      </TextField>
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleOpen}
                  >
                    Select Action Types to be displayed
                  </Button>{" "}
                  <Button
                    variant="contained"
                    color="primary"
                    icon={
                      <RefreshIcon
                        color={
                          this.state.stateChanged ? "#1d1" : "rgba(0, 0, 0, 0)"
                        }
                      />
                    }
                    onClick={this.calculateNewConfig}
                  >
                    Load new data
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Dialog
              contentStyle={{ overflow: "auto" }}
              bodyStyle={{ overflow: "auto" }}
              modal={false}
              open={this.state.openDialog}
              onClose={this.handleClose}
            >
              <DialogTitle>Select Action Types to be displayed</DialogTitle>
              <DialogContent>
                {transactionTypesKeysSorted.map((key, index) => {
                  return (
                    <div key={index + "_type"}>
                      <Checkbox
                        label={key
                          .replace(/([A-Z])/g, " $1")
                          .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")}
                        checked={this.state.actionTypesToDisplay[key]}
                        onClick={this.changeCheckBox.bind(this, key)}
                      />
                    </div>
                  );
                })}
              </DialogContent>
            </Dialog>
          </div>
          {React.cloneElement(this.props.children, {
            ...this.props,
            attachIntervals: this.attachIntervals,
            intervalActive: !!this.state.timerCount,
          })}
        </div>
      </div>
    );
  }
}

StatisticsComponent.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

export const StatisticsDashboard =
  compose(statisticsConnector)(StatisticsComponent);
